import React, { useState, useEffect } from 'react';
import './Header.css';
import { FaPhone, FaWhatsapp, FaBars, FaTimes } from 'react-icons/fa';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('accueil');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      
      // Detect active section
      const sections = ['accueil', 'a-propos', 'services', 'realisations', 'avis', 'contact'];
      const current = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      
      if (current) {
        setActiveSection(current);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      
      setMobileMenuOpen(false);
      setActiveSection(sectionId);
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="header-content">
          {/* Logo with animation */}
          <div className="logo" onClick={() => scrollToSection('accueil')}>
            <div className="logo-icon">
              <span className="logo-letter">P</span>
              <div className="logo-water-drop"></div>
            </div>
            <div className="logo-text">
              <h1>PlumbThe2nd</h1>
              <span className="logo-subtitle">Expert Plomberie</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className={`nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <button 
              onClick={() => scrollToSection('accueil')}
              className={activeSection === 'accueil' ? 'active' : ''}
            >
              Accueil
            </button>
            <button 
              onClick={() => scrollToSection('a-propos')}
              className={activeSection === 'a-propos' ? 'active' : ''}
            >
              À Propos
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className={activeSection === 'services' ? 'active' : ''}
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('realisations')}
              className={activeSection === 'realisations' ? 'active' : ''}
            >
              Réalisations
            </button>
            <button 
              onClick={() => scrollToSection('avis')}
              className={activeSection === 'avis' ? 'active' : ''}
            >
              Avis
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={activeSection === 'contact' ? 'active' : ''}
            >
              Contact
            </button>
          </nav>

          {/* Action Buttons */}
          <div className="header-actions">
            <a 
              href={`tel:+${process.env.REACT_APP_WHATSAPP_NUMBER || '33123456789'}`} 
              className="btn btn-phone"
              aria-label="Appeler"
            >
              <FaPhone /> <span className="btn-text">Appeler</span>
            </a>
            <a 
              href={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER || '33123456789'}`}
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn btn-whatsapp"
              aria-label="WhatsApp"
            >
              <FaWhatsapp /> <span className="btn-text">WhatsApp</span>
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button 
            className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className="mobile-overlay" onClick={toggleMobileMenu}></div>
      )}
    </header>
  );
};

export default Header;
